import React from "react";
import playIcon from "../../assets/images/play-icon.png"

const NextLessonCard = ({ section, onClick }) => {
  if (!section) return null;

  return (
    <div className="next-lesson-card" onClick={onClick}>
      <div className="next-lesson-card-text">
        <div className="next-lesson-card-label">Deine nächste Lektion</div>
        <div className="next-lesson-card-title">{section.name}</div>
      </div>

      <div className="next-lesson-card-right">
        <span className="next-lesson-card-arc next-lesson-card-arc--outer" />
        <span className="next-lesson-card-arc next-lesson-card-arc--mid" />
        <span className="next-lesson-card-arc next-lesson-card-arc--inner" />

        <div className="next-lesson-card-play">
          <img src={playIcon} alt="Play" />
        </div>
      </div>
    </div>
  );
};

export default NextLessonCard;
